import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { dashboardConfig } from '../../config/constants';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { makeStyles } from '@material-ui/core/styles';
import { widgetsConfigMap, widgetsMap } from '../Widget/WidgetConfig';
import { useWidgetsMutation } from '../../hooks';
import WidgetComponent from '../Widget/Widget';
import { generateLayout, layoutColumns, layoutBreakpoints } from './widgetGridLayout';
const ResponsiveGridLayout = WidthProvider(Responsive);
const useStyles = makeStyles((theme) => ({
    masonryContainer: {
        padding: '0 20px 20px 20px',
        width: '100%',
        position: 'relative',
        margin: '0 auto',
        flexGrow: 1,
    },
    '@global': {
        '.react-grid-layout': {
            position: 'relative',
            transition: 'height 200ms ease',
            margin: '0 auto',
        },
        '.react-grid-item': {
            transition: 'all 200ms ease',
            transitionProperty: 'left, top',
        },
        '.react-grid-item.cssTransforms': {
            transitionProperty: 'transform',
        },
        '.react-grid-item.resizing': {
            zIndex: 1,
            willChange: 'width, height',
        },
        '.react-grid-item.react-draggable-dragging': {
            transition: 'none',
            zIndex: 3,
            willChange: 'transform',
        },
        '.react-grid-item.react-grid-placeholder': {
            backgroundColor: 'rgba(70, 188, 1, 0.1)',
            border: `1px dashed ${theme.color.primary.main}`,
            borderRadius: '5px',
            transitionDuration: '100ms',
            zIndex: 0,
            userSelect: 'none',
        },
    },
}));
export const WidgetsGrid = ({ widgets }) => {
    const { mutate: updateWidgets } = useWidgetsMutation();
    const classes = useStyles();
    const mappedWidgets = useMemo(() => {
        var _a;
        return (_a = widgets === null || widgets === void 0 ? void 0 : widgets.filter((widget) => widget.type && !!widgetsMap[widget.type])) === null || _a === void 0 ? void 0 : _a.map((widget) => {
            return { ...widget, ...widgetsConfigMap[widget.type] };
        });
    }, [widgets]);
    const onLayout = useCallback((currentLayout) => {
        if (!widgets) {
            return;
        }
        const updatedWidgetList = widgets.map((widget) => {
            const newPosition = currentLayout.find(({ i }) => i === widget.uuid);
            if (newPosition) {
                return {
                    ...widget,
                    x: newPosition.x,
                    y: newPosition.y,
                };
            }
            return widget;
        });
        updateWidgets(updatedWidgetList);
    }, [widgets, updateWidgets]);
    return (React.createElement("div", { className: classes.masonryContainer, id: dashboardConfig.containerId },
        React.createElement(ResponsiveGridLayout, { className: "layout", layouts: generateLayout(mappedWidgets), cols: layoutColumns, breakpoints: layoutBreakpoints, measureBeforeMount: true, isResizable: false, autoSize: true, draggableHandle: ".widget-header", compactType: "horizontal", onDragStop: onLayout }, mappedWidgets === null || mappedWidgets === void 0 ? void 0 : mappedWidgets.map((widget) => (React.createElement("section", { key: widget.uuid, id: widget.uuid },
            React.createElement(WidgetComponent, { key: widget.uuid, widget: widget })))))));
};
export default WidgetsGrid;
//# sourceMappingURL=WidgetsGrid.js.map